import PropTypes from "prop-types";
import React from "react";

const MAX_PERCENT = 100;

export const CellReceptionDisplay = props => (
  <div
    style={{
      position: "inherit",
    }}
  >
    <div
      style={{
        position: "relative",
        margin: "0 auto",
        height: props.height,
        width: props.width,
      }}
    >
      <div
        style={{
          width: 0,
          height: 0,
          border: "0 solid transparent",
          borderBottom: `${props.height}px solid ${props.background}`,
          borderLeft: `${props.width}px solid transparent`,
          position: "absolute",
          left: 0,
          bottom: 0,
        }}
      ></div>
      <div
        style={{
          width: 0,
          height: 0,
          border: "0 solid transparent",
          borderBottom: `${(props.height * props.percentage) / MAX_PERCENT}px solid ${props.color}`,
          borderLeft: `${(props.width * props.percentage) / MAX_PERCENT}px solid transparent`,
          position: "absolute",
          left: 0,
          bottom: 0,
        }}
      ></div>
    </div>
  </div>
);

CellReceptionDisplay.propTypes = {
  percentage: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  background: PropTypes.string,
};

CellReceptionDisplay.defaultProps = {
  percentage: 100,
  height: 20,
  width: 30,
  color: "#fff",
  background: "#000",
};
